<template>
  <div class="button-menu-wrapper"     @click.stop="$emit('selectLayer', layer)" >
    <span class="new-item stop-event" v-if="isNew">new</span>
    <div class="button-menu stop-event">

        <span class="button-menu-icon base-sprite" :class="getIconType" ></span>
        <span class='button-menu-label' >{{getLabel}}</span>
    </div>
    <sw-button font="fa" :icon="locked ? 'lock' : 'unlock'"
     class="locked-layer full button-template-delete" 
     @click.native.stop.prevent="onLock" />
  </div>
</template>
<script>
//////////////////////////////////////
// IMPORT
/////////////////////////////////////

//////////////////////////////////////
// CLASS
/////////////////////////////////////
export default {
  name: 'ButtonMenu',
  components: {
  },
  beforeCreate () {
  },
  created () {
    this.locked = this.layer.locked
  },
  beforeMount () {
  },
  mounted () {
  },
  beforeUpdate () {
  },
  updated () {
  },
  beforeDestroy () {
  },
  destroyed () {
  },
  data () {
    return { locked:true}
  },
  props: {
    lockable:{
      type:Boolean,
      default:true
    },
    isNew:{
      type:Boolean,
      default:false
    },
    layer:{
      type:Object
    }
  },
  computed: {
     getLabel() {
      switch (this.layer.type) {
        case 'image':
          return 'image'
        case 'textbox':
          return this.layer.text
        default:
          return this.layer.subtype ? this.layer.subtype : this.layer.type
      }
    },
    getIconType() {
      switch (this.layer.type.toLowerCase()) {
        case 'image':
          return 'sprite-images'
        case 'textbox':
          return 'sprite-text'
        default:
          return 'sprite-shape'
      }
    },
  
  },
  methods: {
    onLock(){
      if(this.lockable){
          this.locked = !this.locked
        this.$emit('lockLayer', this.layer)
      }
    
    }
  },
  watch: {}
}
</script>
<style lang="stylus" scoped>
.white-icon
  color #fff
</style>



// WEBPACK FOOTER //
// src/components/buttons/ButtonLayer.vue